/**
 * Constants definition.
 *
 * @type {{PROHIBIT: string, ALLOW: string, ACTIVATE: string, DEACTIVATE: string}}
 */
const BULK_ACTIONS = {
  PROHIBIT: 'prohibit',
  ALLOW: 'allow',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const BULK_ACTIONS_ENUM = Object.keys(BULK_ACTIONS);

const PROHIBIT = BULK_ACTIONS_ENUM[0];
const ALLOW = BULK_ACTIONS_ENUM[1];
const ACTIVATE = BULK_ACTIONS_ENUM[2];
const DEACTIVATE = BULK_ACTIONS_ENUM[3];

export {
  PROHIBIT,
  ALLOW,
  ACTIVATE,
  DEACTIVATE,
  BULK_ACTIONS_ENUM,
  BULK_ACTIONS,
};
